import { render, staticRenderFns } from "./WebsiteCustomerMessages.vue?vue&type=template&id=d0768734&"
import script from "./WebsiteCustomerMessages.vue?vue&type=script&lang=js&"
export * from "./WebsiteCustomerMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports